import { api } from './api';

export interface EmailLabel {
  id: string;
  name: string;
  colour: string;
  emailCount: number;
  createdAt: string;
}

export async function fetchLabels(): Promise<EmailLabel[]> {
  const res = await api.get('/inbox/labels');
  return res.data.labels;
}

export async function createLabel(input: { name: string; colour?: string }): Promise<EmailLabel> {
  const res = await api.post('/inbox/labels', input);
  return res.data;
}

export async function updateLabel(
  labelId: string,
  input: { name?: string; colour?: string },
): Promise<EmailLabel> {
  const res = await api.patch(`/inbox/labels/${labelId}`, input);
  return res.data;
}

export async function deleteLabel(labelId: string): Promise<void> {
  await api.delete(`/inbox/labels/${labelId}`);
}

export async function assignLabelToEmail(emailId: string, labelId: string): Promise<void> {
  await api.post(`/inbox/emails/${emailId}/labels/${labelId}`, {});
}

export async function removeLabelFromEmail(emailId: string, labelId: string): Promise<void> {
  await api.delete(`/inbox/emails/${emailId}/labels/${labelId}`);
}

export async function fetchEmailLabels(emailId: string): Promise<EmailLabel[]> {
  const res = await api.get(`/inbox/emails/${emailId}/labels`);
  return res.data.labels;
}
